import React from "react";
import Alert from "@insightfulscience/atomic-react/Alert";
import Html from "@insightfulscience/smart-react/Html";
import { string } from "prop-types";

const FlashErrorMessage = ({ text }) => (
	<Alert status="error" className="mb-6">
		<Html Tag="span">{text}</Html>
	</Alert>
);

FlashErrorMessage.propTypes = {
	text: string,
};

export default FlashErrorMessage;
